import React from "react";
import { Award, ArrowUpRight } from "lucide-react";

const ET_URL =
  "https://economictimes.indiatimes.com/ai-innovator/profile/brandborn/133204259";

/* "Featured in The Economic Times — AI Innovator" trust badge.
   variants: "hero" (glowing highlight pill) | "footer" (compact) */
export default function ETInnovatorBadge({ variant = "hero" }) {
  if (variant === "footer") {
    return (
      <a
        href={ET_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="et-innovator-badge-footer"
        className="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-rose-500/[0.08] border border-rose-400/25 hover:border-rose-400/50 transition-all text-xs text-rose-100"
      >
        <Award size={14} className="text-rose-300 shrink-0" />
        <span>
          Featured in <b>The Economic Times</b> · AI Innovator
        </span>
        <ArrowUpRight size={12} className="text-rose-300/70" />
      </a>
    );
  }

  return (
    <a
      href={ET_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="et-innovator-badge-hero"
      className="group relative inline-flex items-center gap-3 pl-2 pr-4 py-2 rounded-full border border-rose-400/40 bg-gradient-to-r from-rose-500/[0.14] to-amber-500/[0.10] hover:from-rose-500/[0.24] hover:to-amber-500/[0.16] transition-all shadow-[0_0_24px_rgba(244,63,94,0.25)]"
    >
      <span className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-rose-500 text-white text-[10px] font-extrabold uppercase tracking-widest shrink-0">
        <Award size={11} /> Nominated
      </span>
      <span className="text-[13px] font-semibold text-rose-50">
        Featured in <span className="text-rose-200">The Economic Times</span> —
        AI Innovator: BrandBorn &amp; EcomCatalog.ai
      </span>
      <ArrowUpRight
        size={14}
        className="text-rose-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform shrink-0"
      />
    </a>
  );
}
